<template>
  <div class="call-records">
    <div class="call-records-list" v-if="contactList && contactList.length > 0">
      <div class="call-records-item" v-for="item in contactList" :key="item.id">
        <div class="call-records-item-left">
          <div>回电人姓名： {{ item.from_user_name }}</div>
          <div>回电时间： {{ item.create_time }}</div>
          <div>客户姓名： {{ item.to_user_name }}</div>
          <div>客户手机： {{ item.to_user_phone }}</div>
        </div>
        <div class="call-records-item-right">
          <i v-if="item.record_url" class="el-icon-video-play"  @click="mediaStart(item)"></i>
          <span v-else>未接通</span>
        </div>
      </div>
    </div>
    <div v-else-if="contactList && contactList.length == 0" class="call-records-nodata">
      暂无记录
    </div>
    <van-popup v-model="mediaShow" @close="popupClose">
      <div class="media">
        <audio ref="audio" controls :src="audioUrl"></audio>
      </div>
    </van-popup>
  </div>
</template>

<script>
import workService from "@/apis/work/index.js";

export default {
  data() {
    return {
      mediaShow: false,
      contactList: null,
      audioUrl: '',
    };
  },
  created() {
    this.WorkContactLog();
  },
  methods: {
    popupClose() {
      this.$refs.audio.pause()
    },
    mediaStart(item) {
      this.audioUrl = item.record_url
      this.mediaShow = true
      this.$nextTick(() => {
        this.$refs.audio.play()
      })
    },
    WorkContactLog() {
      const params = {
        work_id: this.$route.query.work_id,
      };
      workService.WorkContactLog(params).then((res) => {
        this.contactList = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.call-records {
  .call-records-list {
  }
  .call-records-item {
    padding: 10px 20px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    .call-records-item-left {
    }
    .call-records-item-right {
      font-size: 24px;
      span {
        font-size: 14px;
      }
    }
  }
}
.call-records-nodata {
  font-size: 20px;
  text-align: center;
  margin-top: 100px;
}
.media {
  // width: 300px;
  // height: 100px;
}
</style>